import { render, staticRenderFns } from "./orderArchiveDialog.vue?vue&type=template&id=6da8d738&scoped=true&"
import script from "./orderArchiveDialog.vue?vue&type=script&lang=js&"
export * from "./orderArchiveDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderArchiveDialog.vue?vue&type=style&index=0&id=6da8d738&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8d738",
  null
  
)

export default component.exports